// src/components/auth/GlassCard.jsx
import { motion } from "framer-motion";

export default function GlassCard({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="
        w-full max-w-lg
        rounded-xl
        bg-white/80
        backdrop-blur-xl
        border border-white/80
        shadow-[0_30px_50px_rgba(30,64,120,0.35)]
        p-5
      "
    >
      {children}
    </motion.div>
  );
}


// // src/components/auth/GlassCard.jsx
// import { motion } from "framer-motion";

// export default function GlassCard({ children }) {
//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 24 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.35 }}
//       className="
//         w-full max-w-md
//         rounded-3xl
//         bg-white/40
//         backdrop-blur-2xl
//         border border-white/50
//         shadow-[0_30px_60px_rgba(0,0,0,0.2)]
//         p-8
//       "
//     >
//       {children}
//     </motion.div>
//   );
// }



// // components/auth/GlassCard.jsx
// import { motion } from "framer-motion";

// export default function GlassCard({ children }) {
//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 24 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.35 }}
//       className="
//         w-full max-w-md
//         rounded-3xl
//         bg-white/30 backdrop-blur-xl
//         border border-white/40
//         shadow-[0_20px_50px_rgba(0,0,0,0.15)]
//         p-6 sm:p-8
//       "
//     >
//       {children}
//     </motion.div>
//   );
// }
